
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { CloneEvent, EditEventTranslation, EventsPage, EventsPagedData, IDefaultLanguage,
    IEditEventPublicPages, IEditEventTranslation, PublishEvent, StartEvent, StopEvent } from '@routes/events/models/event-model';
import { IEvent, IEventItemList, IEventStatus, IFrontdeskEvent, ILocationDateTimeForDropdowns } from '@shared/services/api/legacy/events-service/event-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class EventsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${EventsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events';

    public getEvents(page: EventsPage): Observable<SuccessResponse<EventsPagedData<IEvent>> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<EventsPagedData<IEvent>>>(EventsService.URL + '/index', page).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getEventsList(): Observable<SuccessResponse<IEventItemList> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IEventItemList>>(EventsService.URL + '/all-events').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getEventsForFrontdesk(page: EventsPage): Observable<SuccessResponse<EventsPagedData<IFrontdeskEvent>> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<EventsPagedData<IFrontdeskEvent>>>(EventsService.URL + '/index/frontdesk', page).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateEventTranslations(eventTranslations: EditEventTranslation): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(EventsService.URL + '/translations', eventTranslations).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public cloneEvent(model: CloneEvent): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(EventsService.URL + '/' + model.eventId + '/clone', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public publishEvent(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        const model = new PublishEvent(id);
        return this.http
            .put<SuccessResponse<boolean>>(EventsService.URL + '/publish', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public startEvent(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        const model = new StartEvent(id);
        return this.http
            .put<SuccessResponse<boolean>>(EventsService.URL + '/start', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public stopEvent(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        const model = new StopEvent(id);
        return this.http
            .put<SuccessResponse<boolean>>(EventsService.URL + '/stop', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getLocationDateTimesForDropdown(id: string): Observable<SuccessResponse<ILocationDateTimeForDropdowns> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ILocationDateTimeForDropdowns>>(EventsService.URL + '/' + id + '/dropdown/locationdatetimes').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateLanguages(model: IEditEventTranslation): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(EventsService.URL + '/translations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updatePublicPages(model: IEditEventPublicPages): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(EventsService.URL + '/publicpages', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getDefaultLanguage(id: string): Observable<SuccessResponse<IDefaultLanguage> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IDefaultLanguage>>(EventsService.URL + '/' + id + '/defaultlanguages').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getEventStatus(id: string): Observable<SuccessResponse<IEventStatus> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IEventStatus>>(EventsService.URL + '/' + id + '/statusses').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public syncListWithCrm(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(EventsService.URL + '/' + id + '/request/sync/invitationlist', { }).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
